import request from '@/utils/request'
import config from '@/config/env'
import axios from 'axios'

// 农机预约
export function getAmList(locId) {
    return request({
        baseURL: config.javaBase4,
        url: 'nongshi/screen/machineData/appointList',
        method: 'get',
        data: { locId }
    })
}

// 农机交易
export function getTaskData(locId) {
    return request({
        baseURL: config.javaBase4,
        url: 'nongshi/screen/machineData/jobList',
        method: 'get',
        data: { locId }
    })
}

// 土地承包经营权、集体资源性资产
export function tradeAmountSummary(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'big/data/basicLandAndBusiness',
        method: 'post',
        data
    })
}

// 集体经营性资产权
export function collectiveAssets(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'big/data/basicOpertion',
        method: 'post',
        data
    })
}

// 交易情况信息
export function getTransactionData(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'big/data/transactionStatus',
        method: 'post',
        data
    })
}

// 预挂牌项目列表
export function getListingProjectList(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'big/data/transferList',
        method: 'post',
        data
    })
}

// 竞拍项目列表
export function getAuctionProjectList(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'big/data/getCMSAuctionList',
        method: 'post',
        data
    })
}

// 成交公告
export function getDealNoticeList(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'big/data/listing',
        method: 'post',
        data
    })
}

// 地图地区信息
export function mapAreaInfo(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'big/data/queryTownArea',
        method: 'post',
        data
    })
}

// 获取地图 JSON 数据
export function getMapJSON(name) {
    return axios({
        baseURL: '/map-json',
        url: `${name}.json`,
        method: 'get'
    })
}

// 地图农机标点列表
export function getPointList() {
    return request({
        baseURL: config.javaBase3,
        url: 'farm/machine/queryMachineCondition',
        method: 'get'
    })
}

// 地图需求标点列表
// export function getXQPointList() {
//     return request({
//         baseURL: config.javaBase4,
//         url: 'nongshi/user/machineRequirement/findPage',
//         method: 'get'
//     })
// }

// 地图标点详情
export function getPointDetails(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'farm/machine/queryWorkCondition',
        method: 'get',
        data
    })
}

// 历史轨迹
export function getTrajectoryPoint(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'farm/machine/queryTraceInfo',
        method: 'get',
        data
    })
}

// 经纬度转详细地址
export function lonLatToAddress(data) {
    return request({
        baseURL: 'https://api.tianditu.gov.cn',
        url: 'geocoder',
        method: 'get',
        data
    })
}

// 实时监控图片
export function getMonitorImage(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'farm/machine/queryPhotoList',
        method: 'get',
        data
    })
}

// 作业列表
export function getTaskList(data) {
    return request({
        baseURL: config.javaBase3,
        url: 'farm/machine/queryWorkInfo',
        method: 'get',
        data
    })
}
